import React from 'react';
import _ from 'lodash';

import { PropTypes } from 'prop-types';

import { Button, Container } from './styles';

const ButtonSelect = (props) => {
  const {
    itemComponent,
    isMulti,
    value,
    onChange,
    render,
  } = props;

  return (
    <Container>
      {props.items.map((item, index) => React.createElement(
        itemComponent,
        {
          selected: props.value === item.key || (isMulti && _.includes(value, item.key)),
          onClick: () => onChange(item.key, item),
          key: item.key,
          last: (props.items.length - 1) === index,
        },
        render(item),
      ))}
    </Container>
  );
};

ButtonSelect.propTypes = {
  isMulti: PropTypes.bool,
  itemComponent: PropTypes.any,
  render: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  onChange: PropTypes.func.isRequired,
};

ButtonSelect.defaultProps = {
  itemComponent: Button,
  isMulti: false,
  value: null,
};

export default ButtonSelect;
